/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { ApplicationState } from 'store';
import { useSelector } from 'react-redux';
import { SimulateState } from 'store/modules/simulate_store/types';
import { SimulateAllState } from 'store/modules/simulate_all_store/types';
import FeatureItem from 'components/molecules/feacture_item';
import { Container } from './styles';

interface ChosenSignatureProps {
  dadosPlanCheckout: any;
}

const ChosenSignature = (props: ChosenSignatureProps) => {
  const { dadosPlanCheckout } = props;
  const { assinaturaDigital } = useSelector<ApplicationState, SimulateState>(
    (state) => state.session.simulate,
  );
  const { simulate_all } = useSelector<ApplicationState, SimulateAllState>(
    (state) => state.session.simulate_all,
  );

  return (
    <Container>
      <div className="col-md-12 p-0">
        <div
          className={`card card-plans-new border-${
            dadosPlanCheckout?.layout === 'checkout'
              ? dadosPlanCheckout?.package_name
              : simulate_all?.package_name
          }`}
        >
          <div
            className={`${
              dadosPlanCheckout?.package_name === 'Pacote de Serviços' &&
              'card-header-additional_services'
            } card-header-new px-4 py-2`}
          >
            <p className="m-2 ml-4">
              {dadosPlanCheckout?.package_name === 'Pacote de Serviços' &&
              dadosPlanCheckout?.selected_package[1]?.service_plan_sale[0]?.servico_id === 1
                ? 'Serviços Adicionais'
                : dadosPlanCheckout?.layout === 'checkout'
                ? dadosPlanCheckout?.package_name === 'Pacote de Serviços'
                  ? dadosPlanCheckout?.package_name
                  : `Plano ${dadosPlanCheckout?.package_name}`
                : `Plano ${
                    simulate_all?.package_name
                      ? simulate_all.package_name[0].toUpperCase() +
                        simulate_all.package_name.slice(1).toLowerCase()
                      : ''
                  }`}
              <span>{assinaturaDigital?.assinatura_digital && ' + Assinatura Digital'}</span>
            </p>
          </div>
          <div className="card-body px-5 py-4">
            <h4 className="card-title font-weight-normal my-2">
              {dadosPlanCheckout?.package_name === 'Pacote de Serviços'
                ? 'Sua assinatura de serviços adicionais contém:'
                : dadosPlanCheckout?.layout === 'checkout'
                ? `Sua assinatura ${dadosPlanCheckout?.package_name} contém:`
                : `Sua assinatura ${simulate_all?.package_name} ${simulate_all?.plan_name} contém:`}
            </h4>
            <div className="row">
              <div className="col-12">
                {dadosPlanCheckout?.package_name === 'Pacote de Serviços' ? (
                  <div>
                    {dadosPlanCheckout?.selected_package[1]?.service_plan_sale?.map(
                      (servico: any, index: number) => (
                        <li key={index} className="d-flex align-items-center mt-3">
                          <i
                            className="material-icons mr-2"
                            style={{ color: '#0D875E', fontSize: '20px' }}
                          >
                            check_circle
                          </i>
                          <span className="text-uppercase pt-1">{servico.servico_nome}</span>
                        </li>
                      ),
                    )}
                  </div>
                ) : (
                  <FeatureItem
                    pacote={
                      dadosPlanCheckout?.layout === 'checkout'
                        ? dadosPlanCheckout?.package_name
                        : simulate_all?.package_name
                    }
                    origin="checkout"
                    servicos_pacote={dadosPlanCheckout?.selected_package[1]?.service_plan_sale}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ChosenSignature;
